import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BusinessStatsComponent } from "@m19-board/strategies/strategies/business-stats/business-stats.component";
import { StrategyPageService } from "../strategy-page.service";

@Component({
  selector: "app-strategy-page-business-stats",
  imports: [BusinessStatsComponent],
  styles: ``,
  template: `@if (strategy(); as strategy) {
    <app-business-stats [strategy]="strategy" />
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageBusinessStatsComponent {
  private readonly strategyPageService = inject(StrategyPageService);

  strategy = this.strategyPageService.strategy;
}
